import { useCallback } from 'react';
import { useLocalStorage } from './use-local-storage';

const setCookie = (cookieName, cookieValue, expiresDay) => {
  const d = new Date();
  d.setTime(d.getTime() + expiresDay * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cookieName}=${cookieValue};${expires};domain=${process.env.REACT_APP_DOMAIN};path=/`;
};

const deleteCookies = () => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  }
};

export const useAuth = () => {
  const [token, setToken, removeToken] = useLocalStorage('token');

  const saveToken = useCallback(
    (token) => {
      setToken(token);
      setCookie(process.env.REACT_APP_GQL_REQUEST_MARK, `Bearer ${token}`, 7);
    },
    [setToken]
  );

  const clearToken = useCallback(() => {
    removeToken('token');
    deleteCookies();
  }, [removeToken]);

  return [token, { saveToken, clearToken }];
};
